import React, { ReactElement } from 'react';
import useStylesPageTitleSeparator from './page-title-separator.styles';

const PageTitleSeparator: ReactMemoComponent = React.memo((): ReactElement => {
  const { classes } = useStylesPageTitleSeparator();

  return (
    <div className={classes.pageTitleSeparator} />
  );
});

export default PageTitleSeparator;
